(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-carousel"] && !Shopify.designMode) return;
  try {
    
class ReviewCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('[data-carousel-track]');
    const prev = this.querySelector('[data-carousel-prev]');
    const next = this.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', () => this.scrollByAmount(-1));
    if (next) next.addEventListener('click', () => this.scrollByAmount(1));
  }
  scrollByAmount(direction) {
    if (!this.track) return;
    const card = this.track.querySelector('.review-carousel__card');
    const amount = card ? card.getBoundingClientRect().width + 16 : 300;
    this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  }
}
customElements.define('review-carousel', ReviewCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
class VideoCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('[data-carousel-track]');
    const prev = this.querySelector('[data-carousel-prev]');
    const next = this.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', () => this.scrollByAmount(-1));
    if (next) next.addEventListener('click', () => this.scrollByAmount(1));
  }
  scrollByAmount(direction) {
    if (!this.track) return;
    const slide = this.track.querySelector('.video-carousel__slide');
    const amount = slide ? slide.getBoundingClientRect().width + 16 : 300;
    this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  }
}
customElements.define('video-carousel', VideoCarousel);

  } catch(e) { console.error(e); }
})();
})();
